import { render, staticRenderFns } from "./PageImageCover.vue?vue&type=template&id=94045190&scoped=true"
import script from "./PageImageCover.vue?vue&type=script&lang=js"
export * from "./PageImageCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94045190",
  null
  
)

export default component.exports